<template>
	<div class="page-content__content">
		<div class="notices">
            <NotificationsTable :notification-data="getNotificationList"/> 
			<div class="pagination" v-if="getNotificationPagination?.total > getNotificationPagination?.limit">
				<vue-awesome-paginate
					:total-items="getNotificationPagination.total"
					:items-per-page="getNotificationPagination.limit"
					:max-pages-shown="3"
					v-model="curPage"
				/>
			</div>
		</div>
	</div>
	<PageLoader v-if="isLoading"/>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import NotificationsTable from "@/components/sections/Notifications/NotificationsTable.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";

export default {
	name: "NotificationsPage",
    components: {NotificationsTable, PageLoader},
	async created() {
		await this.requestNotifications();
	},
	computed: {
		curPage: {
			get() {
				return Math.round(this.getNotificationPagination.offset / this.getNotificationPagination.limit) + 1
			},
			set(value) {
				this.updatePagination({offset: (value - 1) * this.getNotificationPagination.limit})
			}
		},
		...mapGetters({
			isLoading: 'isLoading',
			getNotificationList: 'notifications/getNotificationList',
			getNotificationPagination: 'notifications/getNotificationPagination',
		})
	},
	methods: {
		...mapActions({
			requestNotifications: 'notifications/requestNotifications',
			updatePagination: 'notifications/updatePagination',
		})
	}
}
</script>


